document.addEventListener('DOMContentLoaded', function () {
    let block = document.querySelector('.gallery2-slider');
    if (typeof Splide !== 'undefined' && block) {
        new Splide('.gallery2-slider', {
            type: 'loop',
            perPage: 5,
            gap: 20,
            padding: '10%',
            arrows: false,
            pagination: false,
            autoplay: false,

            breakpoints: {
                1024: {
                    perPage: 4,
                    padding: '10%',
                },
                768: {
                    gap: 15,
                    perPage: 3,
                    padding: '10%',
                },
                600: {
                    gap: 10,
                    perPage: 3,
                    padding: '0%',
                }
            }
        }).mount();
    }
});